// @flow
import storage from 'local-storage-fallback';

const AccessTokenKey = 'access_token';

const LocalStorageService = {
  getToken: (): ?string => storage.getItem(AccessTokenKey),
  setToken: (token: string) => storage.setItem(AccessTokenKey, token),
  removeToken: (): void => storage.removeItem(AccessTokenKey),
  getByKey: (key: string): ?string => storage.getItem(key),
  setByKey: (key: string, value: string) => storage.setItem(key, value),
  removeByKey: (key: string): void => storage.removeItem(key)
};

export default LocalStorageService;
